module.exports = __webpack_public_path__ + "static/media/snaphabit-jj.e8a073d9.png";